import React from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';
import '../../Home.css';
import '../../Details.css';
import Arrow from 'react-arrow';
// import {Line} from 'react-lineto';
// import {ArrowSvg, LineOrientation} from 'react-simple-arrows';

class MSE424 extends React.Component {
    state = {
        // courses: [],
    };

    componentDidMount() {
        axios.get(`https://www.sfu.ca/bin/wcm/course-outlines?current/fall/mse/424/d100`)
        .then(res => {
            // this.setState({courses: res.data.info})
        });        
    }

    SelectTerm() {
        var year = new Date()
        
        if (year.getMonth() < 4) {
            return "/spring"
        }
        else if (year.getMonth() < 8) {
            return "/summer"
        }
        else {
            return "/fall"
        }
    }

    CourseOutline() {
        var year = new Date()
        var link1 = "https://www.sfu.ca/students/calendar/"
        var link2 = "/courses/mse/424.html";
        return (link1 + year.getFullYear() + this.SelectTerm() + link2)
    }

    render() {
        // const { courses } = this.state
        return (
        <div className = "grid-container">
            <div className="grid-item back">
                <Link to="/ENGELEC" className="purple back">Back</Link>
            </div>

            <div className="legend-area">
                <div className="legend-item">
                    <Arrow direction="right" shaftWidth={5} shaftLength={30} headWidth={10} headLength={15} fill="#D2222D" stroke="#D2222D" strokeWidth={2}/>
                    <h3>Pre Requisite</h3>
                </div>

                <div className="legend-item">
                    <Arrow direction="left" shaftWidth={5} shaftLength={15} headWidth={10} headLength={15} fill="#FFBF00" stroke="#FFBF00" strokeWidth={2}/>
                    <Arrow direction="right" shaftWidth={5} shaftLength={15} headWidth={10} headLength={15} fill="#FFBF00" stroke="#FFBF00" strokeWidth={2}/>
                    <h3>Co Requisite</h3>
                </div>

                <div className="legend-item">
                    <Arrow direction="right" shaftWidth={5} shaftLength={30} headWidth={10} headLength={15} fill="#238823" stroke="#238823" strokeWidth={2}/>
                    <h3>Required For</h3>
                </div>
            </div>

            <div className="three-two">
                <img src="./Electives/MSE424.png" alt=""/>
            </div>

            {/* <div className="grid-item prereq-3 purple">
                <p className="dark-orange">MSE 223</p>
            </div>

            <div className="grid-item prereq-1 purple">
                <p>80 Units</p>
            </div>

            <div className="grid-item prereq-2 purple">
                <p className="dark-orange">MSE 321</p>
            </div>

            <div className="grid-item main-course purple">
                <p className="dark-orange">MSE 424</p>
            </div> */}

            <div className="grid-item exit">
                <a className="purple exit" href = "https://www.sfu.ca/mechatronics.html" target = "_blank" rel="noopener noreferrer">Exit</a>
            </div>

            {/* <div className="details">
                <h1 className="heading">Course Details</h1>

                <div className="sub-heading">
                    <h3>Course Name: </h3> 
                    <h3 className="sub-section">{courses.dept} {courses.number} - {courses.title}</h3>
                </div>

                <div className="sub-heading">
                    <h3>Credits: </h3>
                    <h3 className="sub-section">{courses.units}</h3>
                </div>

                <div>
                    <h3>Course Description: </h3>
                    <h3 className="course-description">{courses.description} Prerequisite: {courses.prerequisites} {courses.notes} {courses.designation}</h3>
                </div>
            </div> */}

            <div className="details">
                <h1 className="heading">Course Details</h1>

                <div className="sub-heading">
                    <h3>Course Name: </h3> 
                    <h3 className="sub-section">MSE 424 - Microfluidics</h3>
                </div>

                <div className="sub-heading">
                    <h3>Credits: </h3>
                    <h3 className="sub-section">3</h3>
                </div>

                <div>
                    <h3>Course Description: </h3>
                    <h3 className="course-description">The fundamentals and applications of transport phenomena in microstructures. The main objective is to understand the linkages between theoretical processes and practical applications, with particular emphasis on mechatronic systems. Microfluidic tools and methods will be applied in hands-on laboratory projects that design, model/simulate, build, and test microfluidic devices. Prerequisite: MSE 223 (or ENSC 283), MSE 321 (or ENSC 388) and a minimum of 80 credits. </h3>
                </div>

                <div className="sub-heading">
                    <h3>Course Outline: </h3>
                    <h3 className="sub-section">To see SFU's course outline click <a className="left-space" href = {this.CourseOutline()} target = "_blank" rel="noopener noreferrer">here</a></h3>
                </div>
            </div>

            {/* <ArrowSvg start={{ x: 580, y: 276 }} end={{ x: 580, y: 333 }} strokeWidth={3} color="#D2222D" orientation={LineOrientation.VERTICAL} />
            
            <ArrowSvg start={{ x: 640, y: 300 }} end={{ x: 640, y: 333 }} strokeWidth={3} color="#D2222D" orientation={LineOrientation.VERTICAL} />
            <Line x0={640} y0={300} x1={805} y1={300} borderWidth={4} borderColor="#D2222D" />
            <Line x0={805} y0={276} x1={805} y1={300} borderWidth={4} borderColor="#D2222D" />

            <Line x0={355} y0={276} x1={355} y1={303} borderWidth={4} borderColor="#D2222D" />
            <Line x0={352} y0={300} x1={520} y1={300} borderWidth={4} borderColor="#D2222D" />
            <ArrowSvg start={{ x: 520, y: 300 }} end={{ x: 520, y: 333 }} strokeWidth={3} color="#D2222D" orientation={LineOrientation.VERTICAL} /> */}

        </div>
    )
        }
}
export default MSE424;